import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "./ReadMore.css";
import Gfooter from "../Component/Gfooter";

function Subcarddetails() {
  const [products, setProducts] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();


  // Open carousel
  const openCarousel = (images, index) => {
    setCarouselImages(images);
    setSelectedImageIndex(index);
  };

  // Close carousel
  const closeCarousel = () => {
    setSelectedImageIndex(null);
    setCarouselImages([]);
  };

  // Next image
  const showNext = () => {
    setSelectedImageIndex((prev) =>
      prev + 1 < carouselImages.length ? prev + 1 : 0
    );
  };

  // Previous image
  const showPrev = () => {
    setSelectedImageIndex((prev) =>
      prev - 1 >= 0 ? prev - 1 : carouselImages.length - 1
    );
  };

  // Fetch products
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_sub_cards"
        );

        if (res.data.status === true || res.data.success === "1") {
          let productList = res.data.data;

          if (id) {
            const filtered = productList.filter((item) => item.sub_id == id);
            setProducts(filtered);
          } else {
            setProducts(productList);
          }
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("❌ Error fetching product data:", err);
      }
    };

    fetchData();
  }, [id]);

  
  // Update SEO metadata for the selected subcard
  useEffect(() => {
    if (!products.length) return;

    const item = products[0];

    const title =
      item.seo_title?.trim() ||
      item.heading?.trim() ||
      "NLF Solutions";

    const description =
      item.meta_description?.trim() ||
      item.description?.replace(/<[^>]*>/g, "").trim() ||
      "";

    const keywords = [
      item.primary_keyword,
      item.secondary_keywords,
      item.long_tail_keywords,
    ]
      .filter(Boolean)
      .join(", ");

    document.title = title;

    const setMetaTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);

      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }

      tag.content = content;
    };

    const setPropertyTag = (property, content) => {
      let tag = document.querySelector(
        `meta[property="${property}"]`
      );

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    setMetaTag("description", description);

    if (keywords) {
      setMetaTag("keywords", keywords);
    }

    setPropertyTag("og:title", title);
    setPropertyTag("og:description", description);
  }, [products]);


  return (
    <div className="read-top">
      <div className="container">
        <h1 className="our-heading">
          {/* BACK BUTTON */}
    <button
      onClick={() => navigate(-1)}
      className="btn  shadow-sm"
      style={{
        position: "absolute",
        left: "20px",
        top: "20px",
        zIndex: 1000,
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        fontSize: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:"red",
      color:"white"      }}
    >
      ←
    </button>
        </h1>
      </div>

      {products.map((item) => {
        let multiImages = [];
        if (Array.isArray(item.multi_image)) {
          multiImages = item.multi_image;
        } else if (typeof item.multi_image === "string" && item.multi_image !== "") {
          multiImages = item.multi_image.split(",");
        }

        const fullImageURLs = multiImages.map(
          (img) => `https://cyberathon.com/NLF/${img}`
        );

        return (
          <React.Fragment key={item.floor_id}>
            {item.pdf && (
            <div className="d-flex justify-content-end mb-3 me-5">
              <a
                href={`https://cyberathon.com/NLF/${item.pdf}`}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary btn-sm">
                  Download Brochure
                </button>
              </a>
            </div>
          )}
            <div className="container">
              <h2 className="productmore-heading">
                <strong>{item.heading}</strong>
              </h2>
              
            </div>

            <div className="container product-all">
              <div className="row">
                <div className="productmore-detail col-lg-6 col-md-12 col-sm-12">
                  <div className="productmore-info">
                    <img
                      src={`https://cyberathon.com/NLF/${item.image}`}
                      alt={item.heading}
                    />
                    {/* <div
                      className="productmore-content"
                      dangerouslySetInnerHTML={{ __html: item.floor_paragraph }}
                    /> */}
                  </div>
                </div>

                <div className="benefits col-lg-6 col-md-12 col-sm-12">
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </div>
              </div>

              {/* ------------------------------- */}
              {/* MULTI IMAGE SECTION - Only 3 Images */}
              {/* ------------------------------- */}
              <div className="prodmultimgbox mt-4 mb-4">
                {multiImages.length > 0 ? (
                  <>
                    {fullImageURLs.slice(0, 3).map((img, index) => (
                      <div
                        key={index}
                        className="shadow p-3 bg-white rounded prodmultimgmidbox"
                        onClick={() => openCarousel(fullImageURLs, index)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={img}
                          alt={`${item.head1}-${index}`}
                          style={{
                            borderRadius: "5px",
                          }}
                          className="prodmultimg"
                        />
                      </div>
                    ))}

                    {multiImages.length > 3 && (
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => openCarousel(fullImageURLs, 0)}
                      >
                        View All Images
                      </button>
                    )}
                  </>
                ) : (
                  <p className="text-center text-muted">
                    No additional images available.
                  </p>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}

      {/* ------------------------------- */}
      {/* CAROUSEL MODAL */}
      {/* ------------------------------- */}
      {selectedImageIndex !== null && (
        <div
          onClick={closeCarousel}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "90%",
              maxWidth: "900px",
              textAlign: "center",
            }}
          >
            <img
              src={carouselImages[selectedImageIndex]}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                borderRadius: "10px",
                objectFit: "contain",
              }}
              alt=""
            />

            {/* PREV BUTTON */}
            <button
              onClick={showPrev}
              style={{
                position: "absolute",
                top: "50%",
                left: "0",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "none",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              ❮
            </button>

            {/* NEXT BUTTON */}
            <button
              onClick={showNext}
              style={{
                position: "absolute",
                top: "50%",
                right: "0",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "none",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              ❯
            </button>
          </div>
        </div>
      )}

      <Gfooter />
    </div>
  );
}

export default Subcarddetails;
